class Node {
    constructor(id, distance) {
        this.id = id;
        this.next = null;
        this.distance = distance
    }
} 

class LinkedList {
    constructor() {
        this.head = null;
        this.previousNodeId = null 
        this.isVisited = false 
        this.distanceToStartNode = Infinity
    }
    insertAtHead(id, distance) {
        let temp = new Node(id, distance);
        temp.next = this.head;
        this.head = temp;
        return this;
    }
    getHead() {
        return this.head;
    }
}

class Graph {
    constructor(vertices, startNode, finishNode) { 
        this.vertices = vertices;
        this.startNode = startNode
        this.finishNode = finishNode
        this.list = [];                 
        for (let i = 0; i < vertices; i++) {
            let temp = new LinkedList();
            this.list.push(temp);
        }
    }
    addEdge(source, destination, distance) {
        if (source < this.vertices && destination < this.vertices) {
            this.list[source].insertAtHead(destination, distance);
            this.list[destination].insertAtHead(source, distance); //grafo não direcionado
        }
        return this;
    }
}

//Retrocede a partir do finishNode para encontrar o caminho mais curto
//e retorna o ID dos nós do caminho mais curto na ordem.
export function getNodesIdInShortestPathOrder(graph) {
    const nodesInShortestPathOrder = [];
    let currentNodeId = graph.finishNode;
    while (currentNodeId !== null) {
      nodesInShortestPathOrder.unshift(currentNodeId);
      currentNodeId = graph.list[currentNodeId].previousNodeId;
    }
    return nodesInShortestPathOrder;
  }

export function createGraph(numberOfVertices, startNode, finishNode, distances, cenarioId) {
    const graph = new Graph(numberOfVertices, startNode, finishNode)
 
    if (cenarioId === 0) { 
        graph.addEdge(0,1,distances[0])
        graph.addEdge(0,2,distances[1])
        graph.addEdge(0,3,distances[2]) 
        graph.addEdge(1,2,distances[3])
        graph.addEdge(2,3,distances[4])
        graph.addEdge(1,4,distances[5]) 
        graph.addEdge(2,4,distances[6])
        graph.addEdge(4,5,distances[7]) 
        graph.addEdge(4,7,distances[8])
        graph.addEdge(5,6,distances[9])
        graph.addEdge(6,7,distances[10])
        graph.addEdge(6,8,distances[11])
        graph.addEdge(7,8,distances[12])
        graph.addEdge(8,9,distances[13])
        graph.addEdge(8,10,distances[14])
        graph.addEdge(9,11,distances[15])
        graph.addEdge(10,11,distances[16])        
    } else if (cenarioId === 1) { 
        graph.addEdge(0,2,distances[0])
        graph.addEdge(1,3,distances[1])
        graph.addEdge(2,3,distances[2])
        graph.addEdge(2,4,distances[3])
        graph.addEdge(2,5,distances[4])
        graph.addEdge(3,5,distances[5])
        graph.addEdge(4,5,distances[6])
        graph.addEdge(5,6,distances[7])
        graph.addEdge(6,8,distances[8])
        graph.addEdge(7,8,distances[9])
        graph.addEdge(7,9,distances[10])
        graph.addEdge(8,9,distances[11])
        graph.addEdge(8,10,distances[12])
        graph.addEdge(9,11,distances[13])
        graph.addEdge(10,11,distances[14])
    } else if (cenarioId === 2) {
        graph.addEdge(0,1,distances[0])
        graph.addEdge(1,2,distances[1])
        graph.addEdge(0,3,distances[2])
        graph.addEdge(1,3,distances[3])
        graph.addEdge(1,4,distances[4])
        graph.addEdge(2,4,distances[5])
        graph.addEdge(3,5,distances[6])
        graph.addEdge(3,6,distances[7])
        graph.addEdge(4,7,distances[8])
        graph.addEdge(5,6,distances[9])
        graph.addEdge(6,7,distances[10])
        graph.addEdge(5,8,distances[11])
        graph.addEdge(6,8,distances[12])
        graph.addEdge(6,9,distances[13])
        graph.addEdge(7,9,distances[14])
        graph.addEdge(8,10,distances[15])
        graph.addEdge(8,11,distances[16])
        graph.addEdge(9,11,distances[17])
        graph.addEdge(10,11,distances[18])
        graph.addEdge(10,12,distances[19])
        graph.addEdge(11,12,distances[20])
        graph.addEdge(11,13,distances[21])
        graph.addEdge(12,13,distances[22])
        graph.addEdge(12,14,distances[23])
        graph.addEdge(13,14,distances[24])
    }
    return graph
}